// extracted by mini-css-extract-plugin
export default {"flat-button":"flat-button_flat-button__ruH2X"};